import DSIcon from './../../datascope-icon.png';

export function DSSpinner({ size = 140 }: { size?: number }) {
  return (
    <>
      <img
        src={DSIcon}
        alt='DataScope loader'
        style={{
          zIndex: 1001,
          marginBottom: size === 140 ? '10px' : undefined,
          animation: 'spin 4s linear infinite',
          height: `${size}px`,
          width: `${size}px`,
        }}
      />
      <style>{`
                @keyframes spin {
                    0% { transform: rotate(360deg); }
                    100% { transform: rotate(0deg); }
                }
            `}</style>
    </>
  );
}
